import { useQuery } from '@hooks/reactQuery';

import { organisationSettings } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getOrganisationSettings } from '@api/organisationSettings';

import { IItemsResponse } from '@interfaces/common/response';
import { IOrganisationSetting } from '@interfaces/organisation/organisations';

import { ORGANISATION_SETTINGS } from '@constants/queryKeys';

interface IUseQueryOrganisationSettingsReturn {
	organizationSettings: IOrganisationSetting[];
	countOfRecords: number;
	isLoadingOrganisationSettings: boolean;
}

export const useQueryOrganisationSettings = (organisationId?: string): IUseQueryOrganisationSettingsReturn => {
	const {
		page,
		pageSize,
		sortFieldName,
		sortDirection,
	} = useAppSelector(organisationSettings);

	const {
		data,
		isLoading: isLoadingOrganisationSettings,
		isFetching: isFetchingOrganisationSettings,
	} = useQuery<IItemsResponse<IOrganisationSetting>>({
		queryKey: [
			ORGANISATION_SETTINGS,
			page,
			pageSize,
			sortFieldName,
			sortDirection,
		],
		queryFn: () => getOrganisationSettings({
			page,
			pageSize,
			sortFieldName,
			sortDirection,
		}, organisationId),
		enabled: [organisationId],
		refetchOnWindowFocus: false,
	});

	return {
		organizationSettings: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingOrganisationSettings: isLoadingOrganisationSettings || isFetchingOrganisationSettings,
	};
};
